export default "__VITE_ASSET__abf0f8e7__"